import type { ParsedUrlQuery } from 'querystring';
import { safeSplit } from '../../../util/arrays/safeSplit';
import { FilterChoice } from '../types/FilterChoice';
import { parseWholePath } from './path-segments/wholePath';
import { parseQueryParamsToFilters } from './queryParams';

/**
 * Parse a URL for a search page into a FilterChoice object representing configuration for that page
 * @param asPath the actual url seen by the user, eg "/find/text/Australia?etc=ok" rather than "/find/[...slugs]"
 * @param query the query parameters of the request
 */
export const parseSearchUrl = (asPath: string, query: ParsedUrlQuery): FilterChoice => {
  const pathTokens = getPathTokens(asPath);
  const filters = parseWholePath(pathTokens);
  parseQueryParamsToFilters(query, filters);
  return filters;
};

export const getPathTokens = (asPath: string) =>
  safeSplit(asPath, '?')[0]
    .split('/')
    .filter(it => it !== '')
    .map(decodeURIComponent);
